import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  FETCH_MANUFACTURERS,
  FETCH_MANUFACTURERS_FULFILLED,
  FETCH_MANUFACTURERS_REJECTED,
} from 'b2b-apps/shop/manufacturer/redux/manufacturers/actionTypes';
import {
  ManufacturersActions,
  ManufacturersState,
} from 'b2b-apps/shop/manufacturer/redux/manufacturers/types';

const initialState: ManufacturersState = RemoteRecordData.getDefault();

const reducer = (
  state: ManufacturersState = initialState,
  action: ManufacturersActions,
): ManufacturersState => {
  switch (action.type) {
    case FETCH_MANUFACTURERS:
      return Object.assign(RemoteRecordData.init(), {
        data: state.data,
      });

    case FETCH_MANUFACTURERS_FULFILLED:
      return RemoteRecordData.fulfill(
        Object.assign(state.data || {}, action.payload.data),
      );

    case FETCH_MANUFACTURERS_REJECTED:
      return RemoteRecordData.reject(action.payload.error);

    default:
      return state;
  }
};

export { reducer };
